export const convertSeconds = (seconds, placeholder = '-') => {
  let sec = typeof seconds === 'number' ? seconds : Number(seconds);

  if (isNaN(sec)) {
    return placeholder;
  }

  const hours = Math.floor(sec / 3600);
  sec %= 3600;
  const minutes = Math.floor(sec / 60);
  sec %= 60;

  let result = '';

  if (hours > 0) {
    result += hours + ' час ';
  }
  if (minutes > 0) {
    result += minutes + ' мин ';
  }
  if (sec > 0) {
    result += sec + ' с';
  }

  return result.trim();
};
